/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const IsNullPrimitiveString: core.serialization.ObjectSchema<
    serializers.IsNullPrimitiveString.Raw,
    Truvity.IsNullPrimitiveString
> = core.serialization.object({});

export declare namespace IsNullPrimitiveString {
    export interface Raw {}
}
